import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Table from '../../components/Table';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import AMConnectionRow from './connection-row';

import { LIMIT } from './constants';
import messages from './messages';
import './styles.css';

class AMConnectionsTable extends React.PureComponent {
  static propTypes = {
    connections: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onLoadMore: PropTypes.func.isRequired,
    enabledFeatures: PropTypes.array,
    extendedLayout: PropTypes.bool,
    removeDiversityFilters: PropTypes.bool,
  };

  render() {
    const { connections, loading, onLoadMore, extendedLayout, removeDiversityFilters } = this.props;
    const connectionsResults = connections.results;
    const { totalCount, hasNextPage } = connections.pagination;

    const remainder = totalCount - connectionsResults.length;

    return (
      <Table basic="very" styleName="connections-table">
        <caption styleName="ui-header" data-cy="connection-table-header">
          {totalCount > 0 && (
            <FormattedMessage
              {...messages.showingConnectionsCount}
              values={{ count: hasNextPage ? connectionsResults.length : totalCount, total: totalCount }}
            />
          )}
          {totalCount === 0 && <FormattedMessage {...messages.noConnections} />}
        </caption>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell><FormattedMessage {...messages.name} /></Table.HeaderCell>
            {extendedLayout && <Table.HeaderCell><FormattedMessage {...messages.source} /></Table.HeaderCell>}
            {!removeDiversityFilters && <Table.HeaderCell><FormattedMessage {...messages.genderEthnicity} /></Table.HeaderCell>}
            <Table.HeaderCell><FormattedMessage {...messages.birthDate} /></Table.HeaderCell>
            <Table.HeaderCell><FormattedMessage {...messages.gradeYearGPA} /></Table.HeaderCell>
            <Table.HeaderCell><FormattedMessage {...messages.schoolNameCEEB} /></Table.HeaderCell>
            <Table.HeaderCell><FormattedMessage {...messages.contactAddress} /></Table.HeaderCell>
            <Table.HeaderCell><FormattedMessage {...messages.majors} /></Table.HeaderCell>
            {extendedLayout && <Table.HeaderCell><FormattedMessage {...messages.previousCollegeCreditsEarned} /></Table.HeaderCell>}
            {extendedLayout && <Table.HeaderCell><FormattedMessage {...messages.transferBy} /></Table.HeaderCell>}
            <Table.HeaderCell><FormattedMessage {...messages.createdModified} /></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body data-cy="connections-table-body">
          {connectionsResults.map((connection) => (
            <AMConnectionRow
              connection={connection}
              key={connection.id}
              extendedLayout={extendedLayout}
              removeDiversityFilters={removeDiversityFilters}
            />
          ))}
        </Table.Body>
        {hasNextPage && (
        <Table.Footer>
          <Table.Row>
            <Table.Cell colSpan="6">
              <Button primary onClick={onLoadMore} styleName="load-more-btn">
                <FormattedMessage {...messages.showMore} values={{ inc: remainder < LIMIT ? remainder : LIMIT }} />
              </Button>
              <Loader inline active={loading} />
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
        )}
      </Table>
    );
  }
}

export default AMConnectionsTable;
